var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], { autoescape: true });
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/app/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["enso_cms/static/enso-cms/nunjucks-templates/device-files-confirm.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"width-span6\">\n    <h1>Are you sure?</h1>\n    <div class=\"span-100\">\n        ";
if(runtime.contextOrFrameLookup(context, frame, "toBeReplaced")) {
output += "\n        <h3>The following files will be replaced:</h3>\n        <p>\n            ";
frame = frame.push();
var t_3 = runtime.contextOrFrameLookup(context, frame, "toBeReplaced");
if(t_3) {var t_2 = t_3.length;
for(var t_1=0; t_1 < t_3.length; t_1++) {
var t_4 = t_3[t_1];
frame.set("filename", t_4);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += "\n                ";
output += runtime.suppressValue(t_4, env.opts.autoescape);
output += "<br/>\n            ";
;
}
}
frame = frame.pop();
output += "\n        </p>\n        ";
;
}
output += "\n        ";
if(runtime.contextOrFrameLookup(context, frame, "toBeCreated")) {
output += "\n        <h3>The following files will be created:</h3>\n        <p>\n            ";
frame = frame.push();
var t_7 = runtime.contextOrFrameLookup(context, frame, "toBeCreated");
if(t_7) {var t_6 = t_7.length;
for(var t_5=0; t_5 < t_7.length; t_5++) {
var t_8 = t_7[t_5];
frame.set("filename", t_8);
frame.set("loop.index", t_5 + 1);
frame.set("loop.index0", t_5);
frame.set("loop.revindex", t_6 - t_5);
frame.set("loop.revindex0", t_6 - t_5 - 1);
frame.set("loop.first", t_5 === 0);
frame.set("loop.last", t_5 === t_6 - 1);
frame.set("loop.length", t_6);
output += "\n                ";
output += runtime.suppressValue(t_8, env.opts.autoescape);
output += "<br/>\n            ";
;
}
}
frame = frame.pop();
output += "\n        </p>\n        ";
;
}
output += "\n        ";
if(runtime.contextOrFrameLookup(context, frame, "notSupplied")) {
output += "\n        <h3>Warning - The following expected files were not supplied and will not be created or replaced:</h3>\n        <p>\n            ";
frame = frame.push();
var t_11 = runtime.contextOrFrameLookup(context, frame, "notSupplied");
if(t_11) {var t_10 = t_11.length;
for(var t_9=0; t_9 < t_11.length; t_9++) {
var t_12 = t_11[t_9];
frame.set("filename", t_12);
frame.set("loop.index", t_9 + 1);
frame.set("loop.index0", t_9);
frame.set("loop.revindex", t_10 - t_9);
frame.set("loop.revindex0", t_10 - t_9 - 1);
frame.set("loop.first", t_9 === 0);
frame.set("loop.last", t_9 === t_10 - 1);
frame.set("loop.length", t_10);
output += "\n                ";
output += runtime.suppressValue(t_12, env.opts.autoescape);
output += "<br/>\n            ";
;
}
}
frame = frame.pop();
output += "\n        </p>\n        ";
;
}
output += "\n        ";
if(runtime.contextOrFrameLookup(context, frame, "notExpected")) {
output += "\n        <h3>Warning - The following files were not expected and will be ignored:</h3>\n        <p>\n            ";
frame = frame.push();
var t_15 = runtime.contextOrFrameLookup(context, frame, "notExpected");
if(t_15) {var t_14 = t_15.length;
for(var t_13=0; t_13 < t_15.length; t_13++) {
var t_16 = t_15[t_13];
frame.set("filename", t_16);
frame.set("loop.index", t_13 + 1);
frame.set("loop.index0", t_13);
frame.set("loop.revindex", t_14 - t_13);
frame.set("loop.revindex0", t_14 - t_13 - 1);
frame.set("loop.first", t_13 === 0);
frame.set("loop.last", t_13 === t_14 - 1);
frame.set("loop.length", t_14);
output += "\n                ";
output += runtime.suppressValue(t_16, env.opts.autoescape);
output += "<br/>\n            ";
;
}
}
frame = frame.pop();
output += "\n        </p>\n        ";
;
}
output += "\n        <h2>Are you sure you want to go ahead?</h2>\n        <div>\n            <button class=\"cancel-button\">Cancel</button>\n            <button class=\"ok-button\">OK</button>\n        </div>\n    </div>\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["enso_cms/static/enso-cms/nunjucks-templates/device-files-confirm.html"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./enso_cms/static/enso-cms/nunjucks-templates/device-files-confirm.html
// module id = ./enso_cms/static/enso-cms/nunjucks-templates/device-files-confirm.html
// module chunks = main